import { measureText, textElement } from '@syncfusion/ej2-svg-base';
/**
 * Class for Bullet chart axis
 */
export class BulletChartAxis {
    constructor(bullet) {
        //super();
        this.bulletChart = bullet;
        this.isVertical = (bullet.orientation === 'Vertical');
        this.isLabelsInside = (bullet.labelPosition === 'Inside');
        this.isHorizontal = (bullet.orientation === 'Horizontal');
        this.isLeft = bullet.titlePosition === 'Left';
        this.isRight = bullet.titlePosition === 'Right';
        this.isTop = bullet.titlePosition === 'Top';
        this.majorTickSize = bullet.majorTickLines.height;
        this.location = 10;
        this.labelOffset = 15;
        this.labelSize = parseFloat(bullet.labelStyle.size);
        this.isLabelBelow = !this.bulletChart.opposedPosition;
    }
    renderMajorTickLines(intervalValue, scale) {
        if (this.bulletChart.orientation === 'Horizontal') {
            this.renderXMajorTickLines(intervalValue, scale);
        }
        else {
            this.renderYMajorTickLines(intervalValue, scale);
        }
    }
    renderMinorTickLines(intervalValue, scale) {
        if (this.bulletChart.orientation === 'Horizontal') {
            this.renderXMinorTickLines(intervalValue, scale);
        }
        else {
            this.renderYMinorTickLines(intervalValue, scale);
        }
    }
    renderAxisLabels(intervalValue, scale) {
        if (this.bulletChart.orientation === 'Horizontal') {
            this.renderXAxisLabels(intervalValue, scale);
        }
        else {
            this.renderYAxisLabels(intervalValue, scale);
        }
    }
    /**
     * To render grid lines of bullet chart axis.
     *
     * @param {number} intervalValue - The interval value between minor grid lines.
     * @param {Element} scale - The scale element to which the minor grid lines will be appended.
     * @returns {void}
     */
    renderXMajorTickLines(intervalValue, scale) {
        const bullet = this.bulletChart;
        const tickGroup = bullet.renderer.createGroup({ 'id': bullet.svgObject.id + '_majorTickGroup' });
        const min = bullet.minimum;
        const max = bullet.maximum;
        const interval = bullet.interval;
        const enableRtl = bullet.enableRtl;
        const y1 = bullet.initialClipRect.y + ((bullet.opposedPosition) ? 0 : bullet.initialClipRect.height);
        const y2 = y1 + ((!bullet.opposedPosition) ? ((bullet.tickPosition !== 'Inside' ?
            this.majorTickSize : -this.majorTickSize)) : ((bullet.tickPosition !== 'Inside' ? -this.majorTickSize : this.majorTickSize)));
        const majorTick = bullet.majorTickLines;
        let strokeColor = majorTick.color || bullet.themeStyle.majorTickLineColor;
        let options;
        let condition;
        const size = bullet.initialClipRect.x + ((bullet.enableRtl) ? bullet.initialClipRect.width : 0);
        let majorPointX = bullet.initialClipRect.x + majorTick.width / 2 + ((enableRtl) ? bullet.initialClipRect.width : 0);
        for (let i = min; i <= max; i += interval) {
            condition = (!bullet.enableRtl) ? (i === max) : (i === min);
            if (condition) {
                majorPointX -= majorTick.width / 2;
            }
            condition = (!bullet.enableRtl) ? (i === max) : (i === min);
            if (bullet.majorTickLines.useRangeColor) {
                strokeColor = this.bindingRangeStrokes(majorPointX - ((condition) ? this.bulletChart.majorTickLines.width / 2 : 0), size, this.bulletChart.orientation, bullet.enableRtl);
            }
            options = this.majorTicks(majorPointX, majorPointX, y1, y2, strokeColor, i);
            const majorTicks = bullet.renderer.drawLine(options);
            majorPointX = majorPointX + ((enableRtl ? -intervalValue : intervalValue));
            tickGroup.appendChild(majorTicks);
            scale.appendChild(tickGroup);
        }
    }
    /**
     * To render grid lines of bullet chart axis.
     *
     * @param {number} intervalValue - The interval value between minor grid lines.
     * @param {Element} scale - The scale element to which the minor grid lines will be appended.
     * @returns {void}
     */
    renderYMajorTickLines(intervalValue, scale) {
        const bulletChart = this.bulletChart;
        const tickGroup = bulletChart.renderer.createGroup({ 'id': bulletChart.svgObject.id + '_majorTickGroup' });
        const min = bulletChart.minimum;
        const max = bulletChart.maximum;
        const interval = bulletChart.interval;
        const enableRtl = bulletChart.enableRtl;
        const rect = bulletChart.initialClipRect;
        const x1 = rect.x + ((!bulletChart.opposedPosition) ? 0 : rect.width);
        const x2 = x1 - ((!bulletChart.opposedPosition) ? ((bulletChart.tickPosition !== 'Inside' ?
            this.majorTickSize : -this.majorTickSize)) : ((bulletChart.tickPosition !== 'Inside'
            ? -this.majorTickSize : this.majorTickSize)));
        const majorTick = bulletChart.majorTickLines;
        let strokeColor = majorTick.color || bulletChart.themeStyle.majorTickLineColor;
        let condition;
        let options;
        const size = rect.y + ((!bulletChart.enableRtl) ? rect.height : 0);
        let majorPointY = rect.y + majorTick.width / 2 + ((!enableRtl) ? rect.height : 0);
        for (let i = min; i <= max; i += interval) {
            condition = (bulletChart.enableRtl) ? (i === max) : (i === min);
            if (condition) {
                majorPointY -= majorTick.width / 2;
            }
            condition = (!bulletChart.enableRtl) ? (i === max) : (i === min);
            if (bulletChart.majorTickLines.useRangeColor) {
                strokeColor = this.bindingRangeStrokes(majorPointY - ((condition) ? this.bulletChart.majorTickLines.width / 2 : 0), size, this.bulletChart.orientation, bulletChart.enableRtl);
            }
            options = this.majorTicks(x1, x2, majorPointY, majorPointY, strokeColor, i);
            const majorTicks = bulletChart.renderer.drawLine(options);
            majorPointY = majorPointY + ((!enableRtl ? -intervalValue : intervalValue));
            tickGroup.appendChild(majorTicks);
            scale.appendChild(tickGroup);
        }
    }
    majorTicks(x1, x2, y1, y2, strokeColor, i) {
        const options = {
            'id': this.bulletChart.svgObject.id + '_MajorTickLine_' + i,
            'x1': x1,
            'y1': y1,
            'x2': x2,
            'y2': y2,
            'stroke-width': this.bulletChart.majorTickLines.width,
            'stroke': (this.bulletChart.majorTickLines.useRangeColor && strokeColor) ? strokeColor :
                this.bulletChart.majorTickLines.color || strokeColor
        };
        return options;
    }
    bindingRangeStrokes(majorPointX, size, orientation, rtl) {
        if ((orientation === 'Vertical' && !rtl) || (rtl && orientation === 'Horizontal')) {
            return this.backwardStrokeBinding(majorPointX, size);
        }
        else {
            return this.forwardStrokeBinding(majorPointX, size);
        }
    }
    /**
     * To render minor tick lines of bullet chart.
     *
     * @param {number} intervalValue - The interval value between minor tick lines.
     * @param {Element} scaleGroup - The group element to which the minor tick lines will be appended.
     * @returns {void}
     */
    renderXMinorTickLines(intervalValue, scaleGroup) {
        const minorTickGroup = this.bulletChart.renderer.createGroup({ 'id': this.bulletChart.svgObject.id + '_minorTickGroup' });
        const bullet = this.bulletChart;
        const max = bullet.maximum;
        const min = bullet.minimum;
        const interval = bullet.interval;
        const minorTick = bullet.minorTickLines.height;
        const minorTicksPerInterval = this.bulletChart.minorTicksPerInterval;
        let minorPointX;
        let x;
        let majorPointX = bullet.initialClipRect.x;
        const y1 = bullet.initialClipRect.y + ((bullet.opposedPosition) ? 0 : bullet.initialClipRect.height);
        const y2 = y1 + ((!bullet.opposedPosition) ? ((bullet.tickPosition !== 'Inside' ? minorTick : -minorTick)) :
            ((bullet.tickPosition !== 'Inside' ? -minorTick : minorTick)));
        let strokeColor = bullet.minorTickLines.color || bullet.themeStyle.minorTickLineColor;
        let options;
        let minorTicks;
        const size = bullet.initialClipRect.x + ((bullet.enableRtl) ? bullet.initialClipRect.width : 0);
        for (let i = min; i < max; i += interval) {
            minorPointX = intervalValue / minorTicksPerInterval;
            for (let j = 1; j <= minorTicksPerInterval; j++) {
                x = majorPointX + minorPointX - (minorPointX / (minorTicksPerInterval + 1));
                if (bullet.minorTickLines.useRangeColor) {
                    strokeColor = this.bindingRangeStrokes(x, size, this.bulletChart.orientation, bullet.enableRtl);
                }
                options = this.minorXTicks(x, x, y1, y2, strokeColor, i.toString() + j.toString());
                minorTicks = this.bulletChart.renderer.drawLine(options);
                minorTickGroup.appendChild(minorTicks);
                scaleGroup.appendChild(minorTickGroup);
                minorPointX = (intervalValue / minorTicksPerInterval) * (j + 1);
            }
            majorPointX += intervalValue;
        }
    }
    /**
     * To render minor tick lines of bullet chart.
     *
     * @param {number} intervalValue - The interval value between minor tick lines.
     * @param {Element} scaleGroup - The group element to which the minor tick lines will be appended.
     * @returns {void}
     */
    renderYMinorTickLines(intervalValue, scaleGroup) {
        const minorTickGroup = this.bulletChart.renderer.createGroup({ 'id': this.bulletChart.svgObject.id + '_minorTickGroup' });
        const bulletChart = this.bulletChart;
        const max = bulletChart.maximum;
        const min = bulletChart.minimum;
        const interval = bulletChart.interval;
        const minorTick = bulletChart.minorTickLines.height;
        const minorTicksPerInterval = this.bulletChart.minorTicksPerInterval;
        let minorPointY;
        let y;
        let majorPointY = bulletChart.initialClipRect.y + ((!bulletChart.enableRtl) ? bulletChart.initialClipRect.height : 0);
        const x1 = bulletChart.initialClipRect.x + ((!bulletChart.opposedPosition) ? 0 : bulletChart.initialClipRect.width);
        const x2 = x1 - ((!bulletChart.opposedPosition) ? ((bulletChart.tickPosition !== 'Inside' ? minorTick : -minorTick)) :
            ((bulletChart.tickPosition !== 'Inside' ? -minorTick : minorTick)));
        let strokeColor = bulletChart.minorTickLines.color || bulletChart.themeStyle.minorTickLineColor;
        let options;
        let minorTicks;
        const size = bulletChart.initialClipRect.y + ((!bulletChart.enableRtl) ? bulletChart.initialClipRect.height : 0);
        for (let i = min; i < max; i += interval) {
            minorPointY = intervalValue / minorTicksPerInterval;
            for (let j = 1; j <= minorTicksPerInterval; j++) {
                if (!this.bulletChart.enableRtl) {
                    y = majorPointY - minorPointY + (minorPointY / (minorTicksPerInterval + 1));
                }
                else {
                    y = majorPointY + minorPointY - (minorPointY / (minorTicksPerInterval + 1));
                }
                if (bulletChart.minorTickLines.useRangeColor) {
                    strokeColor = this.bindingRangeStrokes(y, size, this.bulletChart.orientation, bulletChart.enableRtl);
                }
                options = this.minorXTicks(x1, x2, y, y, strokeColor, i.toString() + j.toString());
                minorTicks = this.bulletChart.renderer.drawLine(options);
                minorTickGroup.appendChild(minorTicks);
                scaleGroup.appendChild(minorTickGroup);
                minorPointY = (intervalValue / minorTicksPerInterval) * (j + 1);
            }
            majorPointY -= (this.bulletChart.enableRtl) ? -intervalValue : intervalValue;
        }
    }
    minorXTicks(x1, x2, y1, y2, strokeColor, i) {
        const options = {
            'id': this.bulletChart.svgObject.id + '_MajorTickLine_' + i,
            'x1': x1,
            'x2': x2,
            'y1': y1,
            'y2': y2,
            'stroke-width': this.bulletChart.minorTickLines.width,
            'stroke': (this.bulletChart.minorTickLines.useRangeColor && strokeColor) ? strokeColor :
                this.bulletChart.minorTickLines.color || strokeColor
        };
        return options;
    }
    forwardStrokeBinding(position, size) {
        const bullet = this.bulletChart;
        let previous = size;
        // (bullet.orientation === 'Horizontal') ? bullet.initialClipRect.x :
        // (bullet.initialClipRect.y + bullet.initialClipRect.height);
        for (let k = 0; k <= bullet.rangeCollection.length - 1; k++) {
            previous += (!k) ? 0 : bullet.rangeCollection[k - 1];
            if (position >= previous && position < previous + bullet.rangeCollection[k]) {
                return bullet.ranges[k].color;
            }
        }
        return null;
    }
    backwardStrokeBinding(position, size) {
        const bullet = this.bulletChart;
        let previous = size;
        for (let k = 0; k <= bullet.rangeCollection.length - 1; k++) {
            previous -= (!k) ? 0 : bullet.rangeCollection[k - 1];
            if (Math.round(position) >= Math.round(previous - bullet.rangeCollection[k]) && position <= previous) {
                return bullet.ranges[k].color;
            }
        }
        return null;
    }
    /**
     * To render axis labels of bullet chart.
     *
     * @param {number} intervalValue - The interval value between axis labels.
     * @param {Element} scaleGroup - The group element to which the axis labels will be appended.
     * @returns {void}
     */
    renderXAxisLabels(intervalValue, scaleGroup) {
        const axisLabelGroup = this.bulletChart.renderer.createGroup({ 'id': this.bulletChart.svgObject.id + '_axisLabelGroup' });
        let text;
        const bullet = this.bulletChart;
        const locale = this.bulletChart.locale;
        const padding = 5;
        const enableRtl = bullet.enableRtl;
        const tick = (((bullet.tickPosition === bullet.labelPosition) ? bullet.majorTickLines.height : 0) + padding * 2);
        let y = bullet.initialClipRect.y + ((bullet.opposedPosition) ? ((bullet.labelPosition === 'Inside') ? tick : -tick)
            : bullet.initialClipRect.height + ((bullet.labelPosition === 'Inside') ? -tick : tick));
        let x = bullet.initialClipRect.x + ((enableRtl) ? bullet.initialClipRect.width : 0);
        const min = bullet.minimum;
        const max = bullet.maximum;
        const interval = bullet.interval;
        const localizedText = locale && this.bulletChart.enableGroupSeparator;
        const format = this.getFormat(this.bulletChart);
        let strokeColor = bullet.labelStyle.color || bullet.themeStyle.axisLabelFont.color;
        let condition;
        const isCustomFormat = format.match('{value}') !== null;
        this.format = this.bulletChart.intl.getNumberFormat({
            format: isCustomFormat ? '' : format, useGrouping: this.bulletChart.enableGroupSeparator
        });
        const size = bullet.initialClipRect.x + ((bullet.enableRtl) ? bullet.initialClipRect.width : 0);
        y += measureText(this.formatValue(this, isCustomFormat, format, this.bulletChart.maximum), bullet.labelStyle, this.bulletChart.themeStyle.axisLabelFont).height / 3;
        for (let i = min; i <= max; i += interval) {
            condition = (!bullet.enableRtl) ? (i === max) : (i === min);
            if (bullet.labelStyle.useRangeColor) {
                strokeColor = this.bindingRangeStrokes(x - ((condition) ? this.bulletChart.majorTickLines.width / 2 : 0), size, this.bulletChart.orientation, bullet.enableRtl);
            }
            text = localizedText ? i.toLocaleString(locale) : this.formatValue(this, isCustomFormat, format, i);
            const labelOptions = this.labelXOptions(x, y, text, i);
            this.bulletChart.labelStyle.fontFamily = this.bulletChart.labelStyle.fontFamily ||
                this.bulletChart.themeStyle.axisLabelFont.fontFamily;
            const label = textElement(labelOptions, this.bulletChart.labelStyle, strokeColor, scaleGroup, this.bulletChart.themeStyle.axisLabelFont);
            axisLabelGroup.appendChild(label);
            x += (enableRtl) ? -intervalValue : intervalValue;
        }
        scaleGroup.appendChild(axisLabelGroup);
    }
    labelXOptions(labelX, pointY, displayText, i) {
        const labelOptions = {
            'id': this.bulletChart.svgObject.id + '_AxisLabel_' + i,
            'anchor': 'middle',
            'text': displayText,
            'transform': '',
            'x': labelX,
            'y': pointY,
            'baseLine': '',
            'labelRotation': 0
        };
        return labelOptions;
    }
    /**
     * To render axis labels of bullet chart.
     *
     * @param {number} intervalValue - The interval value between the axis labels.
     * @param {Element} scaleGroup - The scale group element to render the axis labels.
     * @returns {void}
     */
    renderYAxisLabels(intervalValue, scaleGroup) {
        const axisLabelGroup = this.bulletChart.renderer.createGroup({ 'id': this.bulletChart.svgObject.id + '_axisLabelGroup' });
        let text;
        const bulletChart = this.bulletChart;
        const locale = bulletChart.locale;
        const padding = 5;
        const enableRtl = bulletChart.enableRtl;
        const tick = (((bulletChart.tickPosition === bulletChart.labelPosition) ?
            bulletChart.majorTickLines.height : 0) + padding * 2);
        let y = bulletChart.initialClipRect.y + ((!enableRtl) ? bulletChart.initialClipRect.height : 0);
        const x = bulletChart.initialClipRect.x + ((!bulletChart.opposedPosition) ?
            ((bulletChart.labelPosition === 'Inside') ? (tick + padding * 2) : -tick)
            : bulletChart.initialClipRect.width + ((bulletChart.labelPosition === 'Inside') ? -(tick + padding * 2) : tick));
        const min = bulletChart.minimum;
        const max = bulletChart.maximum;
        const interval = bulletChart.interval;
        const localizedText = locale && this.bulletChart.enableGroupSeparator;
        let strokeColor = bulletChart.labelStyle.color || bulletChart.themeStyle.axisLabelFont.color;
        const format = this.getFormat(this.bulletChart);
        const isCustomFormat = format.match('{value}') !== null;
        let condition;
        this.format = this.bulletChart.intl.getNumberFormat({
            format: isCustomFormat ? '' : format, useGrouping: this.bulletChart.enableGroupSeparator
        });
        const size = bulletChart.initialClipRect.y + ((!bulletChart.enableRtl) ? bulletChart.initialClipRect.height : 0);
        const labelWidth = measureText(this.formatValue(this, isCustomFormat, format, this.bulletChart.maximum), bulletChart.labelStyle, this.bulletChart.themeStyle.axisLabelFont).width / 2;
        const height = measureText(this.formatValue(this, isCustomFormat, format, this.bulletChart.maximum), bulletChart.labelStyle, this.bulletChart.themeStyle.axisLabelFont).height / 3;
        y += height;
        for (let i = min; i <= max; i += interval) {
            condition = (bulletChart.enableRtl) ? (i === max) : (i === min);
            if (bulletChart.labelStyle.useRangeColor) {
                strokeColor = this.bindingRangeStrokes(y - height - ((condition) ? this.bulletChart.majorTickLines.width / 2 : 0), size, this.bulletChart.orientation, bulletChart.enableRtl);
            }
            text = localizedText ? i.toLocaleString(locale) : this.formatValue(this, isCustomFormat, format, i);
            //labelWidth = measureText(text, bullet.labelStyle).width / 2;
            const labelOptions = this.labelXOptions(x - (!this.bulletChart.opposedPosition ? labelWidth : -labelWidth), y, text, i);
            this.bulletChart.labelStyle.fontFamily = this.bulletChart.labelStyle.fontFamily ||
                this.bulletChart.themeStyle.axisLabelFont.fontFamily;
            const label = textElement(labelOptions, this.bulletChart.labelStyle, strokeColor, scaleGroup, bulletChart.themeStyle.axisLabelFont);
            axisLabelGroup.appendChild(label);
            y += (!enableRtl) ? -intervalValue : intervalValue;
        }
        scaleGroup.appendChild(axisLabelGroup);
    }
    /**
     * Format of the axis label.
     *
     * @private
     */
    getFormat(axis) {
        if (axis.labelFormat) {
            return axis.labelFormat;
        }
        return '';
    }
    /**
     * Formatted the axis label.
     *
     * @private
     */
    formatValue(axis, isCustom, format, tempInterval) {
        return isCustom ? format.replace('{value}', axis.format(tempInterval))
            : axis.format(tempInterval);
    }
}
